import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import { WorkOrder } from "mobx-stores/_models/work-order/work-order";
import { WorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { PaperMaterial } from "../paper-material";

export const PaperGoodsIssueItem = types
  .compose(
    Base,
    types.model({
      materialId: types.maybeNull(types.string),
      material: types.maybeNull(PaperMaterial),
      workOrderId: types.maybeNull(types.string),
      workOrder: types.maybeNull(WorkOrder),
      workOrderPOId: types.maybeNull(types.string),
      workOrderPO: types.maybeNull(WorkOrderPo),
      amount: types.maybeNull(types.number),
      brand: types.maybeNull(types.string),
      rollNumber: types.maybeNull(types.string),
      woNumber: types.maybeNull(types.string),
      length: types.maybeNull(types.number),
      sheetQuantity: types.maybeNull(types.number),
      unitsPerSheet: types.maybeNull(types.number),
      pcsAmount: types.maybeNull(types.number),
      isTakeAll: types.maybeNull(types.boolean),
      isWaste: types.maybeNull(types.boolean),
    }),
  )
  .views((self) => ({
    get pcsAmountRaw() {
      if (self.sheetQuantity && self.unitsPerSheet) {
        return self.sheetQuantity * self.unitsPerSheet;
      }
      return 0;
    },
  }))
  .actions(withSetPropAction);
export interface IPaperGoodsIssueItem extends Instance<
  typeof PaperGoodsIssueItem
> {}
export interface IPaperGoodsIssueItemProperties extends SnapshotIn<
  typeof PaperGoodsIssueItem
> {}

export interface IAddPaperGoodsIssueItem extends Omit<
  IPaperGoodsIssueItemProperties,
  "material" | "workOrder" | "workOrderPO" | keyof IBase
> {}

export interface IUpdatePaperGoodsIssueItem extends Omit<
  IPaperGoodsIssueItemProperties,
  "material" | "workOrder" | "workOrderPO"
> {}
